import Vue from "vue";

Vue.filter("dateTimeFr", function (value) {
  if (!value) {
    return "";
  }
  value = value.toString();
  return value.replace(" ", " à ");
});

Vue.filter("shortDateFr", function (value) {
  if (!value) {
    return "";
  }
  return value.split(" ")[0];
});
